export * from "-!../../../../node_modules/extract-text-webpack-plugin/dist/loader.js??ref--6-0!../../../../node_modules/vue-style-loader/index.js!../../../../node_modules/css-loader/dist/cjs.js??ref--6-2!../../../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../../node_modules/postcss-loader/lib/index.js??ref--6-3!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./chatArea.vue?vue&type=style&index=0&id=7bb8dcb2&scoped=true&lang=css&"


//////////////////
// WEBPACK FOOTER
// ./src/views/classroom1/components/chatArea.vue?vue&type=style&index=0&id=7bb8dcb2&scoped=true&lang=css&
// module id = 6Q+e
// module chunks = 0